<div class="links-wrapper">
	<a class="btn-btn-primary tab-link" routerLink="/about" [ngClass]="{ ' tab-link-active': active === 'about' }">About</a>
	<a class="btn-btn-primary tab-link" routerLink="/contact" [ngClass]="{ ' tab-link-active': active === 'contact' }">Contact</a>
	<a class="btn-btn-primary tab-link" routerLink="/terms" [ngClass]="{ ' tab-link-active': active === 'terms' }">Terms</a>
	<a class="btn-btn-primary tab-link" routerLink="/privacy" [ngClass]="{ ' tab-link-active': active === 'privacy' }">Privacy</a>
</div>
